<script setup lang="ts">
import { defineProps } from "vue";

export interface BreadcrumbProps {
  title: string;
  subtitle: string;
  items: Array<{ text: string; href: string }>;
  to: { text: string; href: string };
}
const props = defineProps<BreadcrumbProps>();
</script>
<template>
  <div class="breadcrumb-area gray-bg">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="breadcrumb-content">
            <div class="breadcrumb-text-wrapper">
              <h2 class="page-name">{{ props.title }}</h2>
              <p class="page-subtitle">{{ props.subtitle }}</p>
            </div>
            <ul class="breadcrumb-list">
              <li v-for="(item, index) in props.items" :key="index">
                <NuxtLink :to="item.href">{{ item.text }}</NuxtLink>
              </li>
              <li>{{ props.to.text }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.page-name{
  color: var(--primary-color);
}
.page-subtitle{
  color: var(--title-color);
}
.breadcrumb-list li:first-child {
  color: var(--subtitle-color);
}
.breadcrumb-list li:last-child {
  color: var(--paragraph-color);
}
</style>
